import React, { useState } from 'react';
import { projects, categories } from '../../data/mock';
import Sparkle from '../Sparkle';
import soundManager from '../../utils/soundEffects';

const ProjectsSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const filteredProjects = selectedCategory === 'All'
    ? projects
    : projects.filter(project => project.category === selectedCategory);

  const handleCategoryClick = (category) => {
    soundManager.playClick();
    setSelectedCategory(category);
  };

  return (
    <div className="window mb-6">
      <div className="window-header">
        <span>🖥️ My Projects 🖥️</span>
      </div>
      <div className="window-body">
        {/* Filter buttons */}
        <div className="flex flex-wrap gap-2 mb-4 items-center">
          <span className="text-2xl animate-pulse">🌟</span>
          {categories.map((category) => (
            <Sparkle key={category} onInteract={() => handleCategoryClick(category)}>
              <button
                className={`retro-btn text-xs ${
                  selectedCategory === category ? 'bg-pink-300' : ''
                }`}
              >
                {category}
              </button>
            </Sparkle>
          ))}
          <span className="text-2xl animate-pulse">✨</span>
        </div>

        {/* Projects grid */}
        <div className="space-y-4">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="bg-gradient-to-br from-yellow-50 to-pink-50 p-4 border-4 border-double border-purple-400"
            >
              {project.featured && (
                <div className="mb-2 flex items-center gap-2">
                  <span className="text-2xl animate-bounce">⭐</span>
                  <span className="bg-pink-400 text-white px-3 py-1 text-xs font-bold">FEATURED</span>
                  <span className="text-2xl animate-bounce">✨</span>
                </div>
              )}
              
              <h3 className="text-xl font-bold pixel-text mb-2" style={{ color: '#ff1493' }}>
                {project.title}
              </h3>
              
              <span className="inline-block px-2 py-1 bg-purple-200 text-xs font-bold mb-2 border border-purple-400">
                {project.category}
              </span>
              
              <p className="text-sm mb-3 leading-relaxed">
                {project.description}
              </p>
              
              <div className="flex flex-wrap gap-1 mb-3">
                {project.technologies.map((tech, idx) => (
                  <span
                    key={idx}
                    className="px-2 py-0.5 bg-white text-xs border border-gray-400"
                  >
                    {tech}
                  </span>
                ))}
              </div>
              
              {project.link && (
                <Sparkle onInteract={() => {
                  soundManager.playSparkle();
                }}>
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => soundManager.playClick()}
                    className="retro-btn text-xs inline-block"
                  >
                    🔗 View Repo
                  </a>
                </Sparkle>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsSection;
